import React from 'react';
import PropTypes from 'prop-types';

const Table = ({ columns = [], data = [], className, rowKey }) => {
  const getKey = (row, idx) => (typeof rowKey === 'function' ? rowKey(row, idx) : row[rowKey] || idx);
  return (
    <div className={className || 'w-full overflow-x-auto border border-succession-border rounded-lg bg-succession-bg-primary shadow-succession-md'}>
      <table className="w-full text-left">
        <thead className="bg-succession-bg-secondary text-succession-text-primary">
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} className="px-4 py-2 text-sm font-medium border-b border-succession-border">{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody className="text-succession-text-primary">
          {data.length === 0 ? (
            <tr>
              <td className="px-4 py-3 text-succession-text-secondary text-sm" colSpan={columns.length}>No data</td>
            </tr>
          ) : (
            data.map((row, rIdx) => (
              <tr key={getKey(row, rIdx)} className="odd:bg-succession-bg-primary even:bg-succession-bg-tertiary hover:bg-succession-hover-bg">
                {columns.map((col, cIdx) => (
                  <td key={cIdx} className="px-4 py-3 border-b border-succession-border text-sm">
                    {typeof col.cell === 'function' ? col.cell(row) : row[col.accessor]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({ header: PropTypes.node, accessor: PropTypes.string, cell: PropTypes.func })
  ),
  data: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default Table;


